<template>
    <Disclosure
        :key="defaultOpen"
        v-slot="{ open }"
        static
        :defaultOpen="defaultOpen"
        as="div"
        class="flex flex-col rounded-muval-2 bg-white shadow"
    >
        <dt class="text-base">
            <DisclosureButton class="flex w-full items-center justify-between gap-2 px-6 py-4">
                <span class="text-base font-medium">{{ title }}</span>
                <SvgIcon
                    name="system-chevron-right"
                    :class="[open ? '-rotate-90' : 'rotate-90', 'transform']"
                    class="h-6 w-6 text-muval-gray-1/50 transition"
                />
            </DisclosureButton>
        </dt>
        <ButterAccordionPanelAnimation>
            <DisclosurePanel
                as="div"
                class="overflow-hidden px-6 pb-4 transition-all duration-500"
                :class="{
                    'border-t pt-4': open && hasBorder,
                }"
            >
                <slot />
            </DisclosurePanel>
        </ButterAccordionPanelAnimation>
    </Disclosure>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        required: false,
        default: 'Default title',
    },
    defaultOpen: {
        type: Boolean,
        required: false,
        default: true,
    },
    hasBorder: {
        type: Boolean,
        required: false,
        default: false,
    },
});
</script>
